<div class="row m-0">
    <div class="col-12 pe-2">
        <div class="row m-0 p-0">
            <div class="px-0 col-6 pe-3">
                <div class="pe-xl-2 pe-lg-2 px-0 widget-container h-100">
                    <div class="d-flex justify-content-between align-items-center p-3 pb-0 m-0">
                        <div class="d-flex align-items-center justify-content-start" style="max-width: 75%">
                            <h4 class="widget-title dpellipsis-total me-2 mb-0"
                                [ngbTooltip]="leftChartTooltip | translate" placement="bottom">
                                {{ leftChartLabel | translate }}
                            </h4>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center align-items-center p-0 pt-3" style="height: 320px">
                        @if (showLoadingLeftChart) {
                            <img src="assets/icons/loading.svg" style="width: 13vh" alt>
                        } @else if (rightLineChart) {
                            <dp-chart [chart]="rightLineChart" class="w-100"></dp-chart>
                        } @else {
                            <h3 class="text-dpprimary">{{ 'statistics.chart.results-not-found' | translate }}</h3>
                        }
                    </div>
                </div>
            </div>

            <div class="px-0 col-6">
                <div class="pe-xl-2 pe-lg-2 px-0 widget-container h-100">
                    <div class="d-flex justify-content-between align-items-center p-3 pb-0 m-0">
                        <div class="d-flex align-items-center justify-content-start" style="max-width: 75%">
                            <h4 class="widget-title dpellipsis-total me-2 mb-0"
                                [ngbTooltip]="rightChartTooltip | translate" placement="bottom">
                                {{ rightChartLabel | translate }}
                            </h4>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center align-items-center p-0 pt-3" style="height: 320px">
                        @if (showLoadingRightChart) {
                            <img src="assets/icons/loading.svg" style="width: 13vh" alt>
                        } @else if (leftLineChart) {
                            <dp-chart [chart]="leftLineChart" class="w-100"></dp-chart>
                        } @else {
                            <h3 class="text-dpprimary">{{ 'statistics.chart.results-not-found' | translate }}</h3>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
